import { render, staticRenderFns } from "./filter-form-component-age.vue?vue&type=template&id=90354244&"
import script from "./filter-form-component-age.vue?vue&type=script&lang=js&"
export * from "./filter-form-component-age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports